import { Reveal, Eyebrow } from "./Reveal";

const TESTIMONIALS = [
  {
    quote: "After taking French for years — in school, in programs in France, and in formal settings like the Alliance Française — I am thrilled to say Cécile is the finest teacher I have ever had. She makes it accessible, fun, and teaches at the highest level.",
    name: "Dr. Elle Lawson",
    role: "Student",
    testid: "testimonial-1",
  },
  {
    quote: "Thanks to her methodical preparation, I passed my TEF on the first try. The mock exams and her precise feedback made all the difference.",
    name: "David R.",
    role: "Professional · Houston",
    testid: "testimonial-2",
  },
  {
    quote: "After two years of conversation lessons, I finally feel at ease in Paris. Cécile combines high standards and kindness like no one else.",
    name: "Emily T.",
    role: "Adult learner · Online",
    testid: "testimonial-3",
  },
];

export default function Testimonials() {
  return (
    <section id="temoignages" className="py-24 lg:py-36 bg-ivory/40 border-y border-sand" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <Eyebrow>They learn with Cécile</Eyebrow>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-6 leading-tight">
            In their own <span className="italic text-gold">words</span>
          </h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-px bg-sand border border-sand">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12} className="bg-cream">
              <figure className="p-10 lg:p-12 h-full flex flex-col" data-testid={t.testid}>
                <span className="font-serif text-7xl leading-none text-gold" aria-hidden="true">“</span>
                <blockquote className="font-serif text-xl leading-relaxed mt-2 flex-1">{t.quote}</blockquote>
                <figcaption className="mt-8">
                  <p className="text-sm font-semibold tracking-wide">{t.name}</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-navy/50 mt-1">{t.role}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
